import { Outlet, Navigate, useLocation } from 'react-router';
import { useEffect } from 'react';
import { isAuthenticated } from '../api/tokenUtils';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { fetchRestaurantsRequest } from '../redux/slices/restaurantSlice';
import { DocsLayout } from '../components/docs/DocsLayout';

export default function ProtectedLayout() {
  const dispatch = useAppDispatch();
  const { isAuthenticated: reduxIsAuthenticated } = useAppSelector(
    state => state.auth
  );
  const { restaurants } = useAppSelector(state => state.restaurant);
  const location = useLocation();

  // Fetch restaurants on mount if authenticated and restaurants not loaded
  useEffect(() => {
    if (reduxIsAuthenticated && restaurants.length === 0) {
      dispatch(fetchRestaurantsRequest());
    }
  }, [dispatch, reduxIsAuthenticated, restaurants.length]);

  if (!isAuthenticated() || !reduxIsAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // For docs routes, analytics, companies, and update-password, don't wrap with DocsLayout
  if (location.pathname.startsWith('/api-reference') || location.pathname.startsWith('/docs') || location.pathname === '/update-password' || location.pathname.startsWith('/analytics') || location.pathname.startsWith('/companies')) {
    return <Outlet />;
  }

  return (
    <DocsLayout>
      <Outlet />
    </DocsLayout>
  );
}
